import React from 'react';
import { WeaFormItem, WeaInput } from 'ecCom';
import { WeaLocaleProvider } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

// 元素类型
class EType extends React.Component {
    state = {
        value: this.props.value,
    };

    render() {
        return (
            <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@qyo4l1`} label={getLabel(382251, '元素类型')} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@kjfl19`} value={this.state.value} viewAttr={1} />
            </WeaFormItem>
        );
    }
}

export default EType;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/EType.js